var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { syntheticEvent } from '../../components/helpers';
import { getState, escHtml, absPosition, bindDelegated, } from './shared';
/** Tab strip with sliding underline indicator */
export function syncNativeTabs(node, parent, ctx) {
    var _a, _b, _c;
    var state = getState(node);
    var labels = (_a = state.tabs) !== null && _a !== void 0 ? _a : ['Tab 1', 'Tab 2'];
    var activeTab = Number((_b = state.activeTab) !== null && _b !== void 0 ? _b : 0);
    var width = Number((_c = state.width) !== null && _c !== void 0 ? _c : 300);
    var tabPct = 100 / Math.max(labels.length, 1);
    var el = ctx.nodeElements.get(node.id);
    if (!el) {
        el = document.createElement('div');
        el.id = node.id;
        el.className = 'lightdraw-tabs';
        el.setAttribute('role', 'tablist');
        parent.appendChild(el);
        bindDelegated(el, function (e) {
            var _a, _b;
            var btn = e.target.closest('.lightdraw-tabs-tab');
            if (!btn)
                return;
            var i = Number(btn.getAttribute('data-index'));
            var tabs = (_a = getState(node).tabs) !== null && _a !== void 0 ? _a : [];
            node.metadata.componentState = __assign(__assign({}, getState(node)), { activeTab: i });
            node.emit('change', syntheticEvent('change', node, { value: i, tab: tabs[i] }));
            (_b = node.getApp()) === null || _b === void 0 ? void 0 : _b.requestRender();
        });
        el.addEventListener('keydown', function (e) {
            var _a, _b, _c;
            var key = e.key;
            if (key !== 'ArrowLeft' && key !== 'ArrowRight' && key !== 'Home' && key !== 'End')
                return;
            e.preventDefault();
            var tabs = (_a = getState(node).tabs) !== null && _a !== void 0 ? _a : [];
            var cur = Number((_b = getState(node).activeTab) !== null && _b !== void 0 ? _b : 0);
            var next = cur;
            if (key === 'ArrowLeft')
                next = Math.max(0, cur - 1);
            if (key === 'ArrowRight')
                next = Math.min(tabs.length - 1, cur + 1);
            if (key === 'Home')
                next = 0;
            if (key === 'End')
                next = tabs.length - 1;
            node.metadata.componentState = __assign(__assign({}, getState(node)), { activeTab: next });
            node.emit('change', syntheticEvent('change', node, { value: next, tab: tabs[next] }));
            (_c = node.getApp()) === null || _c === void 0 ? void 0 : _c.requestRender();
        });
        ctx.nodeElements.set(node.id, el);
    }
    else if (el.parentElement !== parent) {
        parent.appendChild(el);
    }
    var tabsHtml = labels
        .map(function (label, i) {
        return "<button type=\"button\" class=\"lightdraw-tabs-tab".concat(i === activeTab ? ' lightdraw-tabs-tab--active' : '', "\" role=\"tab\" aria-selected=\"").concat(i === activeTab, "\" tabindex=\"").concat(i === activeTab ? 0 : -1, "\" data-index=\"").concat(i, "\">").concat(escHtml(label), "</button>");
    })
        .join('');
    el.innerHTML = "<div class=\"lightdraw-tabs-inner\">".concat(tabsHtml, "<span class=\"lightdraw-tabs-indicator\" style=\"width:").concat(tabPct, "%;left:").concat(activeTab * tabPct, "%\"></span></div>");
    el.style.cssText = absPosition(node, width, 40);
    ctx.applyA11y(node, el);
    ctx.applyUiClasses(node, el);
    ctx.seenIds.add(node.id);
}
/** Collapsible sections */
export function syncNativeAccordion(node, parent, ctx) {
    var _a, _b, _c;
    var state = getState(node);
    var sections = (_a = state.sections) !== null && _a !== void 0 ? _a : [
        { title: 'Section 1', content: 'Content 1' },
        { title: 'Section 2', content: 'Content 2' },
    ];
    var expandedIndex = Number((_b = state.expandedIndex) !== null && _b !== void 0 ? _b : 0);
    var width = Number((_c = state.width) !== null && _c !== void 0 ? _c : 280);
    var el = ctx.nodeElements.get(node.id);
    if (!el) {
        el = document.createElement('div');
        el.id = node.id;
        el.className = 'lightdraw-accordion';
        parent.appendChild(el);
        bindDelegated(el, function (e) {
            var _a, _b, _c, _d;
            var btn = e.target.closest('.lightdraw-accordion-trigger');
            if (!btn)
                return;
            var i = Number(btn.getAttribute('data-index'));
            var secs = (_a = getState(node).sections) !== null && _a !== void 0 ? _a : [];
            var cur = Number((_b = getState(node).expandedIndex) !== null && _b !== void 0 ? _b : 0);
            var next = cur === i ? -1 : i;
            node.metadata.componentState = __assign(__assign({}, getState(node)), { expandedIndex: next });
            node.emit('change', syntheticEvent('change', node, { value: next, section: (_c = secs[i]) === null || _c === void 0 ? void 0 : _c.title }));
            (_d = node.getApp()) === null || _d === void 0 ? void 0 : _d.requestRender();
        });
        ctx.nodeElements.set(node.id, el);
    }
    else if (el.parentElement !== parent) {
        parent.appendChild(el);
    }
    el.innerHTML = sections
        .map(function (sec, i) {
        var open = i === expandedIndex;
        return "<div class=\"lightdraw-accordion-item".concat(open ? ' lightdraw-accordion-item--open' : '', "\">\n        <button type=\"button\" class=\"lightdraw-accordion-trigger\" aria-expanded=\"").concat(open, "\" data-index=\"").concat(i, "\">\n          <span class=\"lightdraw-accordion-chevron\" aria-hidden=\"true\"></span>\n          <span>").concat(escHtml(sec.title), "</span>\n        </button>\n        <div class=\"lightdraw-accordion-panel-wrap\">\n          <div class=\"lightdraw-accordion-panel\">").concat(escHtml(sec.content), "</div>\n        </div>\n      </div>");
    })
        .join('');
    var openPanel = expandedIndex >= 0 ? 48 : 0;
    var estHeight = sections.length * 44 + openPanel;
    el.style.cssText = absPosition(node, width, estHeight);
    ctx.applyA11y(node, el);
    ctx.applyUiClasses(node, el);
    ctx.seenIds.add(node.id);
}
/** Segmented toolbar — icons, separators, wrap on narrow screens */
export function syncNativeToolbar(node, parent, ctx) {
    var _a, _b, _c, _d;
    var state = getState(node);
    var icons = (_a = state.icons) !== null && _a !== void 0 ? _a : [];
    var rawItems = (_c = (_b = state.items) !== null && _b !== void 0 ? _b : state.buttons) !== null && _c !== void 0 ? _c : ['New', 'Open', 'Save'];
    var items = [];
    rawItems.forEach(function (item, i) {
        if (item === '|' || item === null)
            items.push({ type: 'sep' });
        else
            items.push({ type: 'btn', label: item, icon: icons[i] });
    });
    var el = ctx.nodeElements.get(node.id);
    if (!el) {
        el = document.createElement('div');
        el.id = node.id;
        el.className = 'lightdraw-toolbar';
        el.setAttribute('role', 'toolbar');
        parent.appendChild(el);
        bindDelegated(el, function (e) {
            var _a;
            var btn = e.target.closest('.lightdraw-toolbar-btn');
            if (!btn)
                return;
            var label = (_a = btn.getAttribute('data-label')) !== null && _a !== void 0 ? _a : '';
            node.emit('select', syntheticEvent('select', node, { item: label }));
        });
        ctx.nodeElements.set(node.id, el);
    }
    else if (el.parentElement !== parent) {
        parent.appendChild(el);
    }
    var btnIndex = 0;
    el.innerHTML = items
        .map(function (item) {
        if (item.type === 'sep')
            return '<span class="lightdraw-toolbar-separator" role="separator" aria-hidden="true"></span>';
        var iconHtml = item.icon ? "<span class=\"lightdraw-toolbar-icon\" aria-hidden=\"true\">".concat(escHtml(item.icon), "</span>") : '';
        var html = "<button type=\"button\" class=\"lightdraw-toolbar-btn\" data-index=\"".concat(btnIndex, "\" data-label=\"").concat(escHtml(item.label), "\">").concat(iconHtml, "<span>").concat(escHtml(item.label), "</span></button>");
        btnIndex += 1;
        return html;
    })
        .join('');
    var width = Number((_d = state.width) !== null && _d !== void 0 ? _d : 0);
    el.style.cssText = absPosition(node, width > 0 ? width : 'auto', 'auto');
    ctx.applyA11y(node, el);
    ctx.applyUiClasses(node, el);
    ctx.seenIds.add(node.id);
}
/** Editor-style status bar */
export function syncNativeStatusBar(node, parent, ctx) {
    var _a, _b, _c;
    var state = getState(node);
    var segments = (_a = state.segments) !== null && _a !== void 0 ? _a : ['Ready'];
    var width = Number((_b = state.width) !== null && _b !== void 0 ? _b : 400);
    var primaryIndex = Number((_c = state.primaryIndex) !== null && _c !== void 0 ? _c : 0);
    var mono = Boolean(state.mono);
    var el = ctx.nodeElements.get(node.id);
    if (!el) {
        el = document.createElement('div');
        el.id = node.id;
        el.className = 'lightdraw-statusbar';
        el.setAttribute('role', 'status');
        parent.appendChild(el);
        ctx.nodeElements.set(node.id, el);
    }
    else if (el.parentElement !== parent) {
        parent.appendChild(el);
    }
    el.className = "lightdraw-statusbar".concat(mono ? ' lightdraw-statusbar--mono' : '');
    el.innerHTML = segments
        .map(function (s, i) {
        return "<span class=\"lightdraw-statusbar-segment".concat(i === primaryIndex ? ' lightdraw-statusbar-segment--primary' : '', "\">").concat(escHtml(s), "</span>");
    })
        .join('');
    el.style.cssText = absPosition(node, width, 28);
    ctx.applyA11y(node, el);
    ctx.applyUiClasses(node, el);
    ctx.seenIds.add(node.id);
}
